import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();
  const isHomePage = useLocation().pathname === '/';

  const closeMenu = () => setIsMenuOpen(false);
  const openDietPlan = () => {
    navigate('/diet');
    closeMenu();
  };

  const handleSearch = (event) => {
    event.preventDefault();
    const query = search.trim();
    navigate(query ? `/recipes?search=${encodeURIComponent(query)}` : '/recipes');
    setSearch('');
    closeMenu();
  };

  return (
    <header className={`app-header ${isHomePage ? 'home-header' : ''}`}>
      <div className="header-inner">
        <Link to="/" className="header-brand" onClick={closeMenu}>
          <span className="brand-icon" aria-hidden="true">I</span>
          <span className="brand-name">
            Indian Food <span>Delight</span>
          </span>
        </Link>

        <>
          <nav className="header-nav" aria-label="Main navigation">
            <Link className="nav-link-custom" to="/" onClick={closeMenu}>Home</Link>
            <Link className="nav-link-custom" to="/recipes" onClick={closeMenu}>Recipes</Link>
            <button type="button" className="nav-link-custom nav-link-button" onClick={openDietPlan}>Meal Plans</button>
            <Link className="nav-link-custom" to="/marketplace" onClick={closeMenu}>Marketplace</Link>
          </nav>

          <form className="header-search" onSubmit={handleSearch} role="search">
            <label className="visually-hidden" htmlFor="header-recipe-search">Search recipes</label>
            <span aria-hidden="true">⌕</span>
            <input
              id="header-recipe-search"
              type="search"
              placeholder="Find a recipe"
              value={search}
              onChange={(event) => setSearch(event.target.value)}
            />
          </form>

          <button
            type="button"
            className="mobile-menu-toggle"
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
            aria-controls="mobile-navigation"
            onClick={() => setIsMenuOpen((prev) => !prev)}
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>
        </>
      </div>

      <div id="mobile-navigation" className={`mobile-menu-panel ${isMenuOpen ? 'open' : ''}`}>
        <Link className="nav-link-custom" to="/" onClick={closeMenu}>Home</Link>
        <Link className="nav-link-custom" to="/recipes" onClick={closeMenu}>Recipes</Link>
        <button type="button" className="nav-link-custom nav-link-button" onClick={openDietPlan}>Meal Plans</button>
        <Link className="nav-link-custom" to="/marketplace" onClick={closeMenu}>Marketplace</Link>
        <form className="mobile-header-search" onSubmit={handleSearch} role="search">
          <label className="visually-hidden" htmlFor="mobile-recipe-search">Search recipes</label>
          <input
            id="mobile-recipe-search"
            type="search"
            placeholder="Find a recipe"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
          <button type="submit">Search</button>
        </form>
      </div>
    </header>
  );
}

export default Header;
